import { render, staticRenderFns } from "./HeaderLabel.vue?vue&type=template&id=3b2368a8&scoped=true&"
import script from "./HeaderLabel.vue?vue&type=script&lang=js&"
export * from "./HeaderLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2368a8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b2368a8')) {
      api.createRecord('3b2368a8', component.options)
    } else {
      api.reload('3b2368a8', component.options)
    }
    module.hot.accept("./HeaderLabel.vue?vue&type=template&id=3b2368a8&scoped=true&", function () {
      api.rerender('3b2368a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Label/HeaderLabel.vue"
export default component.exports